import axios from '../../utils/axios';

export const fetchLogin = payload => axios.post('/auth/login', payload);

/** 401 is normal when no session cookie; callers treat it as logged out. */
export const fetchMe = () =>
  axios.get('/auth/me', {
    validateStatus: status => status === 200 || status === 401,
    skipAuthLogout: true,
  });

export const fetchFavorites = (id, config = {}) =>
  axios.get(`/favorites/find/${id}`, config);
